import { render, staticRenderFns } from "./GlobalDiscountDistribution.vue?vue&type=template&id=8ccae14e&scoped=true"
import script from "./GlobalDiscountDistribution.vue?vue&type=script&lang=js"
export * from "./GlobalDiscountDistribution.vue?vue&type=script&lang=js"
import style0 from "./GlobalDiscountDistribution.vue?vue&type=style&index=0&id=8ccae14e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccae14e",
  null
  
)

export default component.exports